import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { tap } from "rxjs";
import { TZDProductMasterService } from "../../../core/services/api/tzd-product-master.service";
import { ClearSelectCategory, GetProductCategories, SelectProductCategories } from "../action/product-category.action";
import { APIResponseVM } from "../../../core/models/common/common.model";
import { CategoryListResVM } from "../../../core/models/api/tzd-product-master.model";

export class ProductCategoryStateModel {
  productCategory:APIResponseVM<CategoryListResVM[]> = {
    data: [],
    message: "",
    responseCode: 0
  }
  selectedCategory: null
}

@State<ProductCategoryStateModel>({
  name: "productCategory",
  defaults: {    
    productCategory: {
      data: [],
      message: "",
      responseCode: 0
    },
    selectedCategory: null
  },
})

@Injectable()
export class ProductCategoryState{

  constructor(private tzdProductMasterService: TZDProductMasterService) {}

  @Selector()
  static productCategory(state: ProductCategoryStateModel) {
    return state.productCategory;
  }

  // @Selector()
  // static subCategory(state: ProductCategoryStateModel) {
  //   return state;
  // }

  @Selector()
  static selectedProductCategory(state: ProductCategoryStateModel) {
    return state.selectedCategory;
  }

  @Action(GetProductCategories)
  GetProductCategories(ctx: StateContext<ProductCategoryStateModel>, action: GetProductCategories) {
    const state = ctx.getState();
    if (state?.productCategory?.data?.length > 0) {
      // If the country has been already loaded
      // we just break the execution
      return true;
    }
    return this.tzdProductMasterService.get_active_tzdproductcategory_list().pipe(
      tap({
        next: (result:APIResponseVM<CategoryListResVM[]>) => {
          ctx.patchState({
            productCategory: result
          });
        },
        error: err => {
          throw new Error(err?.error?.message);
        }
      })
    );
  }

  @Action(SelectProductCategories)
  SelectProductCategories(ctx: StateContext<ProductCategoryStateModel>, action: SelectProductCategories) {
    return ctx.setState({
      productCategory:ctx.getState()?.productCategory, // Preserve existing state
      selectedCategory: action.payload // Update only selectedCategory
    });
  }

  @Action(ClearSelectCategory)
  ClearSelectCategory(ctx: StateContext<ProductCategoryStateModel>, action: ClearSelectCategory) {
    return ctx.setState({
      productCategory:ctx.getState()?.productCategory, // Preserve existing state
      selectedCategory: null // Update only selectedCategory
    });
  }
}
